import Loader from "components/Loader";
import { ButtonLink } from "./ButtonLink";
import { formatCurrency } from "utils/utils";
import { useState } from "react";

export function LastSavedItem(props) {
    const { item, actions } = props;
    const [loading, setLoading] = useState(false)

    return (
        <div style={{ position: 'absolute', bottom: '30px' }}>
            <div className="mb-8">
                <div className="col-12">
                    <div className={"underline-btn show-btn pb-15 sm-me-0 active"} style={{
                        width: '100%',
                        margin: 0
                    }}>
                        Your save for later list
                    </div>
                </div>
            </div>

            <Loader isLoading={loading}>
                <div className="row gap-24 pt-32" id="product-row-@item.Id">
                    <div className="col-auto">
                        <img src={item.imageUrl} className="w-h-164" />
                    </div>
                    <div className="col">

                        <div className="row mb-8">
                            <div className="col">
                                <a className="subtitle1 default-text" href={item.fabricUrl} title={item.title}>{item.title}</a>
                            </div>
                            <div className="col-auto align-top mt-1">
                                <span className="curtains-icon curtains-icon-octicon_trash-24 size-24 gray pointer"
                                    onClick={async () => {
                                        if (confirm('Are you sure want to remove this product?')) {
                                            setLoading(!loading);
                                            try {
                                                await actions.onDeleteFavoriteItem(item);
                                            }
                                            finally {
                                                setLoading(false);
                                            }
                                        }
                                    }}></span>
                            </div>
                        </div>

                        <div className="body-text3 active-group sm-text-14">
                            <div>
                                <span className="gray">Collection: </span>
                                <a href={item.collectionUrl} className="underline">
                                    {item.collectionName}
                                </a>
                            </div>
                            <div>
                                <span className="gray">Colour:</span> {item.colour || 'None'}
                            </div>
                            <div>
                                <span className="gray">Qty: {item.quantityUnitPrice}</span>
                            </div>
                        </div>

                        <div className="body-text4 mt-8">{formatCurrency(item.price)}</div>

                        <div className="sm-no">
                            <div className="d-flex gap-32 mt-16 body-text3 color-bg2">
                                <ButtonLink name="Add to Bag"
                                    onClick={async () => {
                                        setLoading(!loading);
                                        try {
                                            await actions.onAddToBag(item);
                                        }
                                        finally {
                                            setLoading(false);
                                        }
                                    }} />
                            </div>
                        </div>

                    </div>
                </div>
                <div className="sm-yes">
                    <div className="d-flex gap-32 mt-16 body-text3 color-bg2">
                        <div className="width-220">
                            <ButtonLink name="Add to Bag"
                                onClick={async () => {
                                    setLoading(!loading);
                                    try {
                                        await actions.onAddToBag(item);
                                    }
                                    finally {
                                        setLoading(false);
                                    }
                                }} />
                        </div>
                    </div>
                </div>
            </Loader>
        </div>
    )
}